export const homepage = {
  pageName: 'homepage',
  title: 'XFL - XFL.com - Official home of the XFL',
  description: 'Learn more about the XFL, kicking off in eight cities in 2020. #XFL2020',
};

export const careers = {
  pageName: 'careers',
  title: 'XFL Careers - XFL.com - Official home of the XFL',
  description: "Interested in working with the XFL? We're searching for talent on and off the field.",
};

export const football = {
  pageName: 'football',
  title: 'XFL Football - XFL.com - Official home of the XFL',
  description: 'Less rules. More action. Find out how the XFL is reimagining football for the better.',
};

export const league = {
  pageName: 'league',
  title: 'XFL League - XFL.com - Official home of the XFL',
  description: 'This league is like no other. Learn all about XFL teams, players, rules, and more.',
};

export const news = {
  pageName: 'news',
  title: 'XFL News - XFL.com - Official home of the XFL',
  description: 'The XFL is all about nonstop action. Keep up with all the latest news about the league.',
};

export const spanishPage = {
  pageName: 'spanish',
  title: 'XFL in Español - XFL.com - Casa oficial de la XFL.',
  description:
    'La XFL tiene que ver con la acción sin parar. Manténgase al día con las últimas noticias sobre la liga.',
};

export const ticketsPage = {
  pageName: 'ickets',
  title: 'XFL Football Tickets - XFL.com - Official home of the XFL',
  description:
    'Learn more about the XFL, kicking off in eight cities in 2020. #XFL2020',
};

export const watchPage = {
  pageName: 'watch',
  title: 'XFL Watch - XFL.com - Official home of the XFL',
  description:
    'Learn more about the XFL, kicking off in eight cities in 2020. #XFL2020',
};



// WEBPACK FOOTER //
// ./src/utils/metadata.js